<template>
  <div class="row justify-content-center align-items-md-center">
    <div class="col-md-6">
      <div class="card full-height bg-ligth">
        <div class="card-header">
          <h3 class="mb-0">{{ lista_campos != '' ? 'Editar' : 'Criar' }} Laboratorio</h3>
        </div>
        <div class="card-body">
          <div class="form">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-md-12">{{$t('NOMBRE.NOME')}}*</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    v-model="form.nome"
                    placeholder="Escribe el nombre..."
                />
              </div>
              
            </div>
             <div class="form-group row">
              <div class="col-md-12 text-center">
                <button
                    @click="confirm(lista_campos == '' ? 'cria' : 'edita')"
                    class="btn btn-primary"
                    :disabled="verif"
                >
                {{$t('GERENCIAR.NOME')}} 
                  <b-spinner
                      v-show="verif"
                      small
                      variant="dark"
                      type="grow"
                      label="Spinning"
                  ></b-spinner>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {fireAlert} from "@/core/mixins/alertMessageMixin";

export default {
  mixins: [fireAlert],
  data() {
    return {
      form: {
        nome: "",
      },
      verif: false,
    };
  },
  created() {
   
    this.preenxerCampos();
  },
  computed: {
    lista_setor() {
      return this.$store.state.configEmpresa.lista_setor;
    },
    lista_filials() {
      return this.$store.state.configEmpresa.lista_filials;
    },
    lista_local() {
      return this.$store.state.configEmpresa.lista_local;
    },
    lista_campos() {
      return this.$store.state.configEmpresa.lista_campos;
    },
    mensagem_alert() {
      return this.$store.state.laboratorio.mensagem_alert;
    },
  },
  methods: {
    async confirm(tipo) {
      await this.$confirm({
        title: "Estas seguro?",
        message: `Esta ação  ` + tipo + ` uma Laboratorio no sistema?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            if (tipo == "cria") this.create();
            if (tipo == "edita") this.update();
          }
        },
      });
    },
    async create() {
      this.verif = true;
      await this.$store.dispatch("laboratorio/create_laboratorio", this.form);
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert, routeName: 'laboratorio'
      });
    },
    
    async update() {
      this.verif = true;
      await this.$store.dispatch("laboratorio/update_laboratorio", this.form);
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert, routeName: 'laboratorio'
      });
    },

    preenxerCampos() {
      if (this.lista_campos != "")
        this.form = {
          id: this.lista_campos.id,
          nome: this.lista_campos.nome,
        };
    },
  },
};
</script>

<style scoped>
.lista:hover {
  background-color: rgb(167, 183, 255);
}
</style>